import { Col, Row, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import programApi from '../../api/program.api'
import ContentHeader from '../../components/shared/ContentHeader'
import styles from '../../styles/sales.module.scss'

const ProgramManagePage = () => {
  const [programs, setPrograms] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    getPrograms()
  }, [])

  const getPrograms = async () => {
    try {
      const res = await programApi.getPrograms()
      // setPrograms(res.data)
      setPrograms([...res.data].reverse())
    } catch (err) {
      console.log('getPrograms err', err)
    } finally {
      setIsLoading(false)
    }
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      // console.log('selectedRows', selectedRows)
      setSelectedRowKeys(selectedRowKeys)
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === 'Disabled User',
    }),
  }

  const columns = [
    {
      title: '프로그램 번호',
      dataIndex: ['program', 'id'],
      key: 'programId',
    },
    {
      title: '프로그램명',
      dataIndex: ['program', 'name'],
      key: 'programName',
    },
    {
      title: '프로그램 설명',
      dataIndex: ['program', 'description'],
      key: 'programDescription',
    },
  ]

  const handleRowClick = (record) => {
    navigate(`/program/detail/${record.program.id}`)
  }

  // useEffect(() => {
  //   console.log('programs', programs)
  // }, [programs])

  return (
    <>
      <ContentHeader title="프로그램 조회/수정/삭제" />
      <div
        className={`${styles['product-register-wrap']}`}
        style={{ minWidth: '1024px' }}
      >
        {/*상품조회 status*/}
        <Row
          justify="space-around"
          className={`${styles['product-search-product-status-wrap']}`}
        >
          {/*전체*/}
          <Col className={`${styles['product-status-box-col-wrap']}`} span={6}>
            <Row className={`${styles['product-status-box-wrap']}`}>
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/product/total_product.png`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>전체</div>
                <div>
                  <span className={`${styles['product-status-num']}`}>
                    {programs.length}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
          </Col>
        </Row>
        {/*프로그램 목록*/}
        <Row
          className={`${styles['product-register-border-box']}`}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <span className={`${styles['product-register-box-title']}`}>
            프로그램 목록 (총{' '}
            <span
              className={`${styles['product-register-box-subtitle']}`}
              style={{ marginLeft: 0 }}
            >
              {programs.length}
            </span>
            개)
          </span>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{ padding: '20px 25px 40px', height: 'fit-content' }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={programs}
            loading={isLoading}
            bordered
            size="middle"
            rowKey={(record) => record.program.id}
            rowClassName="program-table-row"
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
            pagination={false}
            style={{ height: 'fit-content', cursor: 'pointer' }}
          />
        </div>
      </div>
    </>
  )
}

export default ProgramManagePage
